import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config';
import type {
  CheckScreenIpAccessResult,
  SetIpRestrictionBypassParams,
  UpdateSecurityIpAllowlistParams,
  UpdateSecurityIpAllowlistResult,
} from '../../../../types/security';

interface UpdateSecurityIpAllowlistRawResponse {
  success: boolean;
  requires_confirmation: boolean;
  caller_ip: string;
  saved: boolean;
  count?: number;
}

/**
 * 画面（サイト）用 IP 許可リストを更新する（#2982）。
 * 操作者の現在IPが新リストに含まれない場合は requires_confirmation=true で保存されない。
 * force=true で強制保存する。
 */
export const updateSecurityIpAllowlist = async (
  params: UpdateSecurityIpAllowlistParams,
): Promise<UpdateSecurityIpAllowlistResult> => {
  const callable = httpsCallable<
    UpdateSecurityIpAllowlistParams,
    UpdateSecurityIpAllowlistRawResponse
  >(functions, 'updateSecurityIpAllowlist');
  const result = await callable(params);
  return {
    requires_confirmation: result.data.requires_confirmation,
    caller_ip: result.data.caller_ip,
    saved: result.data.saved,
    count: result.data.count,
  };
};

interface CheckScreenIpAccessRawResponse {
  success: boolean;
  data: CheckScreenIpAccessResult;
}

/**
 * ログイン中ユーザーが現在の送信元 IP で画面にアクセス可能か判定する（#2982）。
 * IpRestrictionGate（403ゲート）用。
 */
export const checkScreenIpAccess = async (): Promise<CheckScreenIpAccessResult> => {
  const callable = httpsCallable<Record<string, never>, CheckScreenIpAccessRawResponse>(
    functions,
    'checkScreenIpAccess',
  );
  const result = await callable({});
  return result.data.data;
};

/**
 * テナントの IP 制限を一時無効化 / 解除する（#2982・運営 admin 専用）。
 * 全許可 IP の誤設定によるロックアウトの救済用。
 */
export const setIpRestrictionBypass = async (
  params: SetIpRestrictionBypassParams,
): Promise<void> => {
  const callable = httpsCallable<SetIpRestrictionBypassParams, { success: boolean }>(
    functions,
    'setIpRestrictionBypass',
  );
  await callable(params);
};
